module.exports = "/_next/static/images/26252a0f77543a2dad4e258dd7ed8762-security-desktop.jpg";